export const typesBalance = {
  DEBIT: 'debit',
  DEPOSIT: 'deposit',
};
